import { styled } from '@linaria/react'

export const SVGWrapper = styled.div`
  --icon-none: none;

  position: relative;
  display: flex;

  &[type='ion'] {
    svg * {
      fill: ${props => (props.type === 'ion' ? 'var(--icon-base)' : '')};
    }
  }
`

export const SVGInlineWrapper = styled.div`
  --icon-none: none;

  display: inline-flex;
  position: relative;

  svg {
    width: 100%;
    height: inherit;
    display: flex;
  }

  &[type='ion'] {
    svg * {
      fill: ${props => (props.type === 'ion' ? 'var(--icon-base)' : '')};
    }
  }
`
